module.exports = "/_next/static/images/d94c080085a2e67bcfc439b9d817225f-card-background-right-xs.jpg";